document.addEventListener("DOMContentLoaded", function () {

  // ==========================
  // Desktop Tabs
  // ==========================
  document.querySelectorAll(".product-details-tabs").forEach(function (section) {

    const buttons = section.querySelectorAll(".product-tab-btn");
    const panels = section.querySelectorAll(".product-tab-panel");

    if (!buttons.length || !panels.length) return;

    buttons.forEach(function (button) {

      button.addEventListener("click", function () {

        const target = button.dataset.tab;

        buttons.forEach(function (btn) {
          btn.classList.remove("active");
        });

        panels.forEach(function (panel) {
          panel.classList.remove("active");
        });

        button.classList.add("active");

        const activePanel = section.querySelector("#" + target);

        if (activePanel) {
          activePanel.classList.add("active");
        }

      });

    });

  });


  // ==========================
  // Mobile Accordion Animation
  // ==========================
  document.querySelectorAll(".product-tab-accordion-item").forEach(function (accordion) {

    const summary = accordion.querySelector("summary");

    if (!summary) return;

    summary.addEventListener("click", function (event) {

      if (
        window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
        accordion.dataset.animating === "true"
      ) {
        return;
      }

      event.preventDefault();

      accordion.dataset.animating = "true";

      const startHeight = accordion.offsetHeight;
      let endHeight;

      if (accordion.open) {

        endHeight = summary.offsetHeight;

      } else {

        accordion.style.height = startHeight + "px";
        accordion.open = true;
        endHeight = accordion.scrollHeight;

      }

      const animation = accordion.animate(
        {
          height: [startHeight + "px", endHeight + "px"]
        },
        {
          duration: 260,
          easing: "ease-in-out"
        }
      );

      animation.onfinish = function () {

        if (startHeight > endHeight) {
          accordion.open = false;
        }

        accordion.style.height = "";
        delete accordion.dataset.animating;

      };

    });

  });

});